// extracted by mini-css-extract-plugin
export default {"whyalco_container":"WhyAlco_whyalco_container__-X6O6","whyalco_content":"WhyAlco_whyalco_content__HZkDQ"};